import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'
import KeenSlider from 'keen-slider'
import { prepareSlides, initSliderWrapper, initArrows } from '@/lib/keen-slider.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { sliderWrapper, sliderElement, prev, next } = zelektor(node)
    const { currentBrand } = node.dataset
    const brands = currentBrand != ''
        ? window.theme.brands.filter(brand => brand.vendor_name != currentBrand).filter(brand => brand.show_in_slider === true)
        : window.theme.brands.filter(brand => brand.show_in_slider === true)


    /*******************************************************************************************************************************************/
    /* Insert Brands
    /*******************************************************************************************************************************************/
    insertBrands()

    function insertBrands() {
        const gender = localStorage.getItem('spreeglee_gender') || 'unisex'

        brands.forEach(brand => {
            const linkUrl = brand[`link_url_${gender}`]
            if (linkUrl) {
                const element = document.createElement('li')
                element.classList.add('brand-logos__item')
                element.innerHTML =     `
                                        <a href="${linkUrl ? linkUrl : ''}">
                                            <img src="${brand.logo_dark}" alt="${brand.vendor_name}">
                                        </a>
                                        `
                sliderElement.appendChild(element)
            }
        })
    }


    /*******************************************************************************************************************************************/
    /* Init Slider
    /*******************************************************************************************************************************************/
    prepareSlides(sliderElement)

    let autoplay

    const slider = new KeenSlider(sliderElement, {
        slidesPerView: 5,
        spacing: 50,
        duration: 800,
        loop: true,
        centered: true,
        breakpoints: {
            '(max-width: 1440px)': {
                slidesPerView: 5
            },
            '(max-width: 1024px)': {
                slidesPerView: 3
            },
            '(max-width: 768px)': {
                slidesPerView: 2
            },
            '(max-width: 512px)': {
                slidesPerView: 1
            }
        },

        created: slider => {
            initSliderWrapper(sliderWrapper)
            initArrows(slider, prev, next)
            autoplay = setAutoPlay(slider)
        },

        slideChanged: slider => {
            // updateSlides(slider, sliderElement)
        },
        dragStart: () => {
            clearInterval(autoplay)
        }
    })


    /*******************************************************************************************************************************************/
    /* Update Slides
    /*******************************************************************************************************************************************/
    function updateSlides(slider, sliderElement) {
        const sliderData = slider.details()
        const slides = [...sliderElement.children]
        
        slides.forEach((slide, index) => {
            if (index < sliderData.relativeSlide || index > sliderData.relativeSlide + sliderData.slidesPerView - 1) {
                slide.classList.remove('is-in-view')
            } else {
                slide.classList.add('is-in-view')
            }
        })
    }


    /*******************************************************************************************************************************************/
    /* Slider Autoplay
    /*******************************************************************************************************************************************/
    function setAutoPlay(slider) {
        return setInterval(() => {
            const sliderData = slider.details()
            slider.moveToSlide(sliderData.relativeSlide + 1)
        }, 2000)
    }


    /*******************************************************************************************************************************************/
    /* Destroy / Restore autoplay based on window width
    /*******************************************************************************************************************************************/
    let currentWidth = window.innerWidth > 1024 ? 'large' : 'small'
    
    if (currentWidth === 'large') {
        clearInterval(autoplay)
    }

    window.addEventListener('resize', handleWindowResize)

    function handleWindowResize() {
        if (window.innerWidth > 1024 && currentWidth === 'small') {
            clearInterval(autoplay)
            currentWidth = 'large'
        }

        if (window.innerWidth <= 1024 && currentWidth === 'large') {
            autoplay = setAutoPlay(slider)
            currentWidth = 'small'
        }
    }
})